module.exports = __webpack_public_path__ + "img/de_Ecran 3.788c7ab1.png";